import React from "react";
import { Link } from "react-router-dom";
import aboutStudio from "../../assets/images/ale2.jpg";
import cvPdf from "../../assets/Alessandro_Giustini_CV_26_ITA.pdf";
import { SiteHeader } from "./SiteHeader";
import "./LandingGrid.css";
import "./AboutPage.css";

const year = new Date().getFullYear();

export default function AboutPage() {
  return (
    <div className="lg-page">
      <section className="lg-root about-root" aria-label="Who I am">
        <div className="lg-grid-bg" aria-hidden="true" />

        <SiteHeader />

        <div className="lg-divider" aria-hidden="true" />
        <p className="lg-vertical about-vertical">
          COMPOSER · SOUND DESIGNER · BASED IN ROME
        </p>

        <main className="about-main">
          <div className="about-media">
            <img src={aboutStudio} alt="Alessandro Giustini at work" />
          </div>

          <div className="about-body">
            <div className="about-grid-panel" aria-hidden="true">
              <div className="about-grid-panel-bg" />
              <span className="lg-cross about-cross--a">+</span>
              <span className="lg-cross about-cross--b">+</span>
              <span className="lg-cross about-cross--c">+</span>
              <span className="lg-cross about-cross--d">+</span>
            </div>

            <div className="about-copy-block">
              <h1 className="lg-section-kicker">
                <span>03</span>
                <span className="lg-section-kicker-rule" aria-hidden="true" />
                <span>WHO I AM</span>
              </h1>

              <p className="about-copy">
                Alessandro Giustini is a composer and sound designer who tailors
                music like a craftsman with the vision of a dreamer. His work{" "}
                <b>bridges</b> the raw edge of <b>electronic experimentation</b>{" "}
                and the depth of <b>classical composition</b>, moving fluidly
                between <b>clubs</b>, <b>cinemas</b> and sound installations. He
                trained in film scoring at Italy&apos;s prestigious{" "}
                <b>Centro Sperimentale di Cinematografia</b>.
              </p>

              <dl className="about-meta">
                <div>
                  <dt>Base</dt>
                  <dd>Rome, Italy</dd>
                </div>
                <div>
                  <dt>Practice</dt>
                  <dd>Score · Sound · Live</dd>
                </div>
                <div>
                  <dt>Training</dt>
                  <dd>CSC — Film Scoring</dd>
                </div>
              </dl>

              <div className="about-actions">
                <a
                  className="about-cv"
                  href={cvPdf}
                  download="Alessandro_Giustini_CV.pdf"
                >
                  Download CV →
                </a>
                <Link to="/works" className="lg-section-link">
                  Selected works
                </Link>
                <Link to="/contact" className="lg-section-link lg-section-link--accent">
                  Start a project
                </Link>
              </div>

              <div className="about-credits">
                <p>Text by Giulia Maria Scrocchi</p>
                <p>Design by Andrea Davide</p>
                <p>Photo: @she.s.lola</p>
                <div className="about-credits-links">
                  <a
                    href="https://www.instagram.com/ag.lunatik"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Instagram
                  </a>
                  <a
                    href="https://www.imdb.com/name/nm15848320/?ref_=ext_shr_lnk"
                    target="_blank"
                    rel="noreferrer"
                  >
                    IMDb
                  </a>
                  <a href="mailto:hello@alessandrogiustini.com">
                    hello@alessandrogiustini.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>

        <div className="lg-footer about-footer">
          <span className="lg-footer-rule" aria-hidden="true" />
          <span className="lg-copy">©{year}</span>
        </div>
      </section>
    </div>
  );
}
